<app-sp-page-error (pageButtonClick)="onButtonClick()" buttonText="Logout" title="Account not available" subtitle="{{blockedReason}}" [imageType]="ImageType.DENIED">
    <p>Please <a href="https://soprism.com/#contact" matTooltip="Contact us." matTooltipHideDelay="10">contact us</a> if you think this is a mistake.
    </p>
</app-sp-page-error>
  